type FlutterMessage = {
  postMessage: (message: string) => void;
};

declare global {
  // eslint-disable-next-line no-var
  var platformShare: FlutterMessage;
}

function isNativeShareAvailable(): boolean {
  return navigator.share != undefined;
}

function isPlatformShareAvailable(): boolean {
  return window.platformShare != undefined || window.flutter_inappwebview != undefined;
}

export function isShareAvailable(): boolean {
  return isNativeShareAvailable() || isPlatformShareAvailable();
}

export function share(shareData: ShareData) {
  if (isNativeShareAvailable()) {
    return navigator.share(shareData);
  }

  if (isPlatformShareAvailable()) {
    const shareMessage = JSON.stringify(shareData);
    if (window.platformShare) {
      return window.platformShare.postMessage(shareMessage);
    }
    if (window.flutter_inappwebview) {
      return window.flutter_inappwebview.callHandler('platformShare', shareMessage);
    }
  }

  throw new Error('Share is not available on this platform');
}
